import React from 'react'
import { BookOpen, Users, Award, AlertCircle, Clock } from 'lucide-react'

interface KPIOverviewProps {
  totalSubjects: number
  totalAssignments: number
  totalStudents: number
  completionRate: number
  pendingUnlockRequests: number
}

export const KPIOverview: React.FC<KPIOverviewProps> = ({
  totalSubjects,
  totalAssignments,
  totalStudents,
  completionRate,
  pendingUnlockRequests
}) => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '20px',
      marginBottom: '24px'
    }}>
      {/* Total Students Card */}
      <div className="kpi-card" style={{
        background: 'var(--bg-card, #ffffff)',
        border: '1px solid var(--border-color, rgba(0, 0, 0, 0.1))',
        borderRadius: '16px',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
        transition: 'all 0.3s ease',
        cursor: 'default'
      }}>
        <div style={{
          background: 'rgba(59, 130, 246, 0.1)',
          color: '#3b82f6',
          borderRadius: '12px',
          padding: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Users size={24} />
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-secondary, #64748b)' }}>นักเรียนทั้งหมด</p>
          <h3 style={{ margin: '4px 0 0 0', fontSize: '24px', fontWeight: 700 }}>
            {totalStudents.toLocaleString('th-TH')} <span style={{ fontSize: '14px', fontWeight: 500 }}>คน</span>
          </h3>
        </div>
      </div>

      {/* Completion Rate Card */}
      <div className="kpi-card" style={{
        background: 'var(--bg-card, #ffffff)',
        border: '1px solid var(--border-color, rgba(0, 0, 0, 0.1))',
        borderRadius: '16px',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.02)'
      }}>
        <div style={{
          background: 'rgba(16, 185, 129, 0.1)',
          color: '#10b981',
          borderRadius: '12px',
          padding: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Award size={24} />
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-secondary, #64748b)' }}>อัตราส่งคะแนนสำเร็จ</p>
          <h3 style={{ margin: '4px 0 0 0', fontSize: '24px', fontWeight: 700 }}>
            {completionRate.toFixed(1)}<span style={{ fontSize: '16px' }}>%</span>
          </h3>
        </div>
      </div>

      {/* Total Subjects Card */}
      <div className="kpi-card" style={{
        background: 'var(--bg-card, #ffffff)',
        border: '1px solid var(--border-color, rgba(0, 0, 0, 0.1))',
        borderRadius: '16px',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.02)'
      }}>
        <div style={{
          background: 'rgba(139, 92, 246, 0.1)',
          color: '#8b5cf6',
          borderRadius: '12px',
          padding: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <BookOpen size={24} />
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-secondary, #64748b)' }}>วิชาที่สอนทั้งหมด</p>
          <h3 style={{ margin: '4px 0 0 0', fontSize: '24px', fontWeight: 700 }}>
            {totalSubjects} <span style={{ fontSize: '14px', fontWeight: 500 }}>วิชา ({totalAssignments} ห้องเรียน)</span>
          </h3>
        </div>
      </div>

      {/* Pending Unlock Requests Card */}
      <div className="kpi-card" style={{
        background: 'var(--bg-card, #ffffff)',
        border: '1px solid var(--border-color, rgba(0, 0, 0, 0.1))',
        borderRadius: '16px',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          background: pendingUnlockRequests > 0 ? 'rgba(239, 68, 68, 0.1)' : 'rgba(100, 116, 139, 0.1)',
          color: pendingUnlockRequests > 0 ? '#ef4444' : '#64748b',
          borderRadius: '12px',
          padding: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {pendingUnlockRequests > 0 ? <AlertCircle size={24} className="pulse-icon" /> : <Clock size={24} />}
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-secondary, #64748b)' }}>คำร้องรออนุมัติ</p>
          <h3 style={{
            margin: '4px 0 0 0',
            fontSize: '24px',
            fontWeight: 700,
            color: pendingUnlockRequests > 0 ? '#ef4444' : 'inherit'
          }}>
            {pendingUnlockRequests} <span style={{ fontSize: '14px', fontWeight: 500, color: 'var(--text-secondary, #64748b)' }}>คำร้อง</span>
          </h3>
        </div>
      </div>
    </div>
  )
}
